<script lang="ts">
    export default { name: 'EmojiInsert' };
</script>

<script lang="ts" setup>
    import { ref, computed } from 'vue';
    import BSDropdownButton from '@shared/components/BSDropdownButton.vue';
    import type { EmojiCategory } from '@shared/modules/emoji-data';

    const emit = defineEmits<{
        select: [emoji: string];
    }>();

    const props = defineProps<{
        btnClass?: string;
    }>();

    const categories = (window as unknown as { emojiCategories: EmojiCategory[] }).emojiCategories;
    const activeId = ref(categories[0].id);
    const activeCategory = computed(() => categories.find((c) => c.id === activeId.value)!);

    const getHeading = (cat: EmojiCategory) => {
        const key = cat.titleKey.charAt(0).toUpperCase() + cat.titleKey.slice(1);
        return $Resources[key];
    };
</script>

<template>
    <div class="emoji-insert">
        <BSDropdownButton :dropdownAsDiv="true" :closeOnClickInside="true" :btnClass="props.btnClass" menuClass="dropdown-menu-right">
            <template #toggle>😊</template>
            <template #content>
                <ul class="tabs list-unstyled tabs-emojis text-center" role="tablist">
                    <li role="presentation" :class="{ active: cat.id === activeId }" v-for="cat in categories">
                        <a href="javascript:void(0)" role="tab" :key="cat.id" :title="getHeading(cat)" @click.stop="activeId = cat.id">
                            {{ cat.iconEmoji }}
                        </a>
                    </li>
                </ul>

                <h3 class="h6">{{ getHeading(activeCategory) }}</h3>

                <ul class="emoji-list list-unstyled">
                    <li v-for="emoji in activeCategory.emojis" :key="emoji">
                        <a href="javascript:void(0)" role="button" @click="emit('select', emoji)">
                            {{ emoji }}
                        </a>
                    </li>
                </ul>
            </template>
        </BSDropdownButton>
    </div>
</template>

<style lang="less">
    /*
    .emoji-insert-menu .emoji-tab-btn {
        background: none;
        border: 1px solid transparent;
        border-radius: var(--ug-border-radius, 4px);
        cursor: pointer;
        font-size: 1.1rem;
        line-height: 1;
        padding: 2px 4px;
    }

    .emoji-insert-menu .emoji-tab-btn.active,
    .emoji-insert-menu .emoji-tab-btn:hover {
        border-color: var(--brand-primary, #337ab7);
        background: var(--ug-bg-subtle, #f5f5f5);
    }

    .emoji-insert-menu .emoji-list {
        display: flex;
        flex-wrap: wrap;
        // max-height: 200px;
        // overflow-y: auto;
        gap: 2px;
    }

    .emoji-insert-menu .emoji-list a {
        font-size: 1.25rem;
        line-height: 1;
        padding: 3px;
        border-radius: var(--ug-border-radius, 4px);
        text-decoration: none;
    }

    .emoji-insert-menu .emoji-list a:hover {
        background: var(--ug-bg-subtle, #f5f5f5);
    }
        */
</style>
